import { create } from 'zustand';

type NavigationBarStore = {
  isSiderOpen: boolean;
  openSider: () => void;
  closeSider: () => void;
  toggleSider: () => void;
};

export const useNavigationBarStore = create<NavigationBarStore>((set) => ({
  isSiderOpen: true,
  openSider: () => set({ isSiderOpen: true }),
  closeSider: () => set({ isSiderOpen: false }),
  toggleSider: () => set((state) => ({ isSiderOpen: !state.isSiderOpen })),
}));
